module.exports = __webpack_public_path__ + "img/wallet-card.fba73389.svg";